export default __webpack_public_path__ + "static/media/tool-item-h5-bg1.5a36762e.png";